const PAGINATION = {
  LIMIT: 10,
};

export type ColumnProps = {
  align?: 'left' | 'right' | 'center';
  width?: string;
};

const COLUMN_STYLES: { [key: string]: ColumnProps } = {
  role: { align: 'center', width: '80px' },
};

const CONFIG = {
  PAGINATION,
  COLUMN_STYLES,
} as const;

export default CONFIG;
